export default __webpack_public_path__ + "static/media/external-link.9f93bc83.svg";